import React, { Component } from 'react';
import Hls from 'hls.js';

export default class HLSSource extends Component {
    constructor(props) {
        super(props);
        this.state = { loading: false };
        this.hls = new Hls({
            // enableWorker: true,
            enableWorker: false,
            debug: false,
            maxBufferSize: 5,
            maxBufferLength: 20,
            liveBackBufferLength: 0
        });
    }

    loadSource(src) {
        this.setState({ loading: true });
        this.hls.loadSource(src);
    }

    initPlayer() {
        const { src, video } = this.props;

        if (Hls.isSupported()) {
            this.loadSource(src);
            this.hls.attachMedia(video);
            this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                this.setState({ loading: false });

                video.play();
            });
        }
    }

    componentDidMount() {
        this.initPlayer();
    }

    componentDidUpdate(prevProps, prevState) {
        const { src } = this.props;
        if (prevProps.src !== src && !this.state.loading) {
            this.loadSource(src);
        }
    }

    componentWillUnmount() {
        // destroy hls video source
        if (this.hls) {
            this.hls.destroy();
        }
    }

    render() {
        return <source src={this.props.src} type={this.props.type || 'application/x-mpegURL'} />;
    }
}
